import React, { Component } from 'react';
import {OrdinalFrame, XYFrame, ResponsiveXYFrame} from "semiotic";
import employmentData from './employment-data'
import { scaleTime } from 'd3-scale'


// console.log(employmentData);

class SampleChart extends Component {

    handleWaypointEnter() {
        //console.log("Enter")
    }

    handleWaypointLeave() {
        //console.log("Leave")

    }
    render() {

        return (
            <div className="chart-container" style={{width: '700px'}}>
                <ResponsiveXYFrame
                    title={"Coal Miner Employment (Bureau of Labor Statistics)"}
                    responsiveWidth={true}
                    size={[700, 400]}
                    lines={employmentData}
                    xScaleType={scaleTime()}
                    xAccessor={(d, i) => {
                        let date = new Date(d["Date"]);
                        //console.log(date);
                        return date;
                    }}
                    yAccessor={"Employees"}
                    lineStyle={{ stroke: "#00a2ce" }}
                    margin={{ left: 80, bottom: 50, right: 20, top: 40 }}
                    axes={[
                        {
                            orient: "left",
                            label: "Employees (thousands)"
                        },
                        {
                            orient: "bottom",
                            label: "Year",
                            tickFormat: d => {
                                //console.log(d);
                                return d.getFullYear()
                            },
                            ticks: 8,
                        }
                    ]}
                />
            </div>
        );
    }
}

export default SampleChart;



// WEBPACK FOOTER //
// ./src/EmploymentChart.jsx